import React from 'react';
import { Input, Select, Icon,DatePicker,Col,Row } from 'antd';
import moment from 'moment';

const  tipo_requeremiento = [ {codigo:1, nombre:"Bienes"}, {codigo:2, nombre:"Servicios"} ]
const { Option } = Select;

class Filters extends React.Component {
    render() {
        return (
            <div className="filfer-container">
            <Row gutter={16}>
          
                <Col className="gutter-row" sm={24} md={12} lg={4}>
      
                    <Select 
                          showSearch labelInValue
                          value={
                              this.props.filter.idEntidad ?
                                  { key: this.props.filter.idEntidad } : undefined
                          }
                            placeholder={"Seleccione Entidad"}
                            optionFilterProp="children"
                            onChange={(option) => this.props.onChange('idEntidad', option.key)}
                        >
                            {this.props.entidades.map(item => (
                                <Option key={item.id} value={item.id}>{item.nombre}</Option>
                            ))}
                        </Select>

                </Col>

                        
                <Col className="gutter-row" sm={24} md={12} lg={4}>

                        <Select
                            showSearch labelInValue
                            value={
                                this.props.filter.idEstado ?
                                    { key: this.props.filter.idEstado } : undefined
                            }
                            placeholder={"Seleccione Estado"}
                            optionFilterProp="children"
                            onChange={(option) => this.props.onChange('idEstado', option.key)}
                        >
                            {this.props.estado.map(item => (
                                <Option key={item.id} value={item.id}>{item.nombre}</Option>
                            ))}
                        </Select>

                </Col>

                        
                <Col className="gutter-row" sm={24} md={12} lg={4}>

                        <Select
                            showSearch labelInValue
                            value={
                                this.props.filter.idTipoAntividad ?
                                    { key: this.props.filter.idTipoAntividad } : undefined
                            }
                            placeholder={"Seleccione Tipo"}
                            optionFilterProp="children"
                            onChange={(option) => this.props.onChange('idTipoAntividad', option.key)}
                        >
                            {tipo_requeremiento.map(item => (
                                <Option key={item.codigo} value={item.codigo}>{item.nombre}</Option>
                            ))}
                        </Select>

                </Col>

                <Col className="gutter-row" sm={24} md={12} lg={3}>
                    <Input
                        prefix={<Icon type="filter" style={{ color: 'rgba(0,0,0,.25)' }} />}
                        value={this.props.filter.serie}
                        onChange={(e) => this.props.onChange("serie", e.target.value)}
                        onKeyUp={this.props.onKeyUpSearch}
                        placeholder="Filtrar por serie"
                        autoComplete="off"
                    />
                </Col>
                <Col className="gutter-row" sm={24} md={12} lg={3}>
                    <Input
                        prefix={<Icon type="filter" style={{ color: 'rgba(0,0,0,.25)' }} />}
                        value={this.props.filter.documento}
                        onChange={(e) => this.props.onChange("documento", e.target.value)}
                        onKeyUp={this.props.onKeyUpSearch}
                        placeholder="Filtrar por documento"
                        autoComplete="off"
                    />
                </Col>
                <Col className="gutter-row" sm={24} md={12} lg={3}>
                    <DatePicker
                        placeholder="Filtrar por fecha inicio"
                        format="DD/MM/YYYY"
                        value={this.props.filter.fechaInicioStr === '' ? null : moment(this.props.filter.fechaInicioStr, 'DD/MM/YYYY')}
                        onChange={(moment, value) => this.props.onChange('fechaInicioStr', value)}
                    />
                </Col>
                <Col className="gutter-row" sm={24} md={12} lg={3}>
                    <DatePicker
                        placeholder="Filtrar por fecha fin"
                        format="DD/MM/YYYY"
                        value={this.props.filter.fechaFinStr === '' ? null : moment(this.props.filter.fechaFinStr, 'DD/MM/YYYY')}
                        onChange={(moment, value) => this.props.onChange('fechaFinStr', value)}
                    />
                </Col>
            </Row>
        </div>
        );
    }
}

export default Filters;